import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/home/home.vue';
import About from './views/about/about.vue';
import Projects from './views/projects/projects.vue';
import NotFound from './views/not-found/not-found.vue';
import Contact from './views/contact/contact.vue';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', component: Home },
    { path: '/about', component: About },
    { path: '/projects', component: Projects },
    { path: '/contact', component: Contact },
    { path: '*', component: NotFound },
  ],
  mode: 'history',
  scrollBehavior: function() {
    return { x: 0, y: 0 };
  }
});
